import { POSTPONED_ACTIONS_REDUCER_KEY } from './postponedActionsReducer';

const getStore = (state) => state[POSTPONED_ACTIONS_REDUCER_KEY];
export const getPostponedActions = (state: any) => getStore(state).postponedActions;

